import React, { FC } from 'react';
import styles from './Icon.scss';
import type { IconProps } from './Icon.types';

export const Icon: FC<IconProps> = ({ imageUrl, onMouseDown, dataHook }) => (
  <div className={styles.iconWrapper} data-hook={dataHook} onMouseDown={onMouseDown}>
    <div className={styles.icon} style={{ backgroundImage: imageUrl }} />
  </div>
);
